export default {
      id: "LWS-5px-usage",
      viewBox: "0 0 60 5",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-5px",
      toString: function () {
        return this.url;
      }
    }